import { render, staticRenderFns } from "./SupervisorUniqueKey.vue?vue&type=template&id=53af78fa&lang=pug&"
import script from "./SupervisorUniqueKey.vue?vue&type=script&lang=js&"
export * from "./SupervisorUniqueKey.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorUniqueKey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SupervisorUniqueKey.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCardActions,
  VCardText,
  VContainer,
  VDivider,
  VFlex,
  VLayout,
  VTextField,
})
